import React from "react";
import {Link} from "react-router-dom";

const ComponentError = ({error, resetErrorBoundary}) => {
    return <>

        <main>
            <div className="site-content">

                <div className="section-group" style={{minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center"}}>

                    <div className="section section-default text-center">

                        <div className="container container-sm">
                            <h2 className="section-title">Nåt gick fel.</h2>
                            <div>
                                Tyvärr uppstod ett fel när sidan skulle laddas. Du kan testa att ladda om sidan i webbläsaren
                                eller kontrollera din internetanslutning. Om problemet kvarstår kan du gå tillbaka till startsidan
                                eller kontakta vår support.
                            </div>
                            <Link to={"/"} className="button mt-4 button-arrow">Gå till startsidan</Link>

                        </div>

                    </div>
                </div>


            </div>
        </main>
    </>
}

export default ComponentError;
